/** Default JSON bodies for manual FE tool runs in developer mode. */
export const FE_TOOL_DEBUG_PARAM_PRESETS: Record<string, Record<string, unknown>> = {
  fe_show: {
    ref: "app:case-checking",
  },
  fe_close: {},
  fe_open_ask_ani: {
    draft: "Proofread the highlighted paragraph",
  },
};

export function defaultFeToolDebugParams(toolId: string): Record<string, unknown> {
  return FE_TOOL_DEBUG_PARAM_PRESETS[toolId] ?? {};
}

export function formatFeToolDebugParams(toolId: string): string {
  return JSON.stringify(defaultFeToolDebugParams(toolId), null, 2);
}
